<div class="container-fluid">
    <div class="row mt-5">
        <div class="col-12 jumbotron text-center">
            <h1 class="display-4">404</h1>
            <p>Página no encontrada</p> 
            <button matTooltip="Ir al dashboard" type="button" class="btn-none" (click)="onMain()">
                <i class="fa-solid fa-circle-arrow-right fa-2x text-info"></i>
            </button>
        </div>
    </div>
</div>